import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import ChapterHeader from "./ChapterHeader";
import ChapterTable from "./ChapterTable";

const ChapterList = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <ChapterHeader />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <ChapterTable />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default ChapterList;
